import { ComponentType } from '@angular/cdk/portal';
import { EventEmitter, Injectable } from '@angular/core';
import { Enums } from '../../enums/enums';
import { SnackbarType } from '../../enums/standalone/snackbar-type.enum';
import { ModelSnackBarDetails } from '../../models/snackbar/snackbar-details.model';
import { ModelSnackBarNotificationRequestData } from '../../models/snackbar/snackbar-notification-request-data.model';
import { AppMonitoring } from '../monitoring/monitor.app';
import { ISnackbarBase } from '../../models/snackbar/snackbar-base.model';

@Injectable({
    providedIn: 'root'
})
export class AppSnackBar {

    onSnackbar: EventEmitter<ISnackbarBase> = new EventEmitter<ISnackbarBase>();
    onDismissSnackbar = new EventEmitter();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _callbackOnAction: ((response?: any) => void) | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get callbackOnAction(): ((response?: any) => void) | undefined {
        return this._callbackOnAction;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private set callbackOnAction(v: ((response?: any) => void) | undefined) {
        this._callbackOnAction = v;
    }

    constructor(private readonly appMonitor: AppMonitoring) { }

    /**
     * Displays a snackbar with the specified component and optional callback function.
     * This is to display a more complex snackbar. To display a simple snackbar, use the default snackBar.open(message, action).
     * 
     * @param type The kind of snackbar to display (selects the snackbar model).
     * @param componentToShow The component to be displayed in the snackbar.
     * @param data Data passed to the snackbar component.
     * @param callbackFunction An optional callback function to be executed when an action is performed on the snackbar.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    showSnackbar(type: SnackbarType, componentToShow: ComponentType<any>, data: any, callbackFunction?: (response?: any) => void): void {
        let details;
        switch (type) {
            case Enums.SnackbarType.NotificationRequest:
                details = new ModelSnackBarNotificationRequestData(componentToShow, callbackFunction, data);
                break;
            case Enums.SnackbarType.Example:
                details = new ModelSnackBarDetails(componentToShow, callbackFunction);
                break
            default:
                this.appMonitor.logException(this, 'Invalid snackbar type');
                    break;
        }
        this.callbackOnAction = callbackFunction;
        this.onSnackbar.emit(details);
    }

    /**
     * Dismisses the snackbar and triggers the callback function if available.
     * 
     * @param response - The optional response to pass to the callback function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dismissSnackBar(response?: any): void {
        if (this.callbackOnAction) {
            this.callbackOnAction(response);
        }
        this.onDismissSnackbar.emit();
    }
}
